<template>
  <div class="child-item" @click="$nav('Family.DrinkInfo', {id: item.id})" :class="{ loss_status }">
    <div class="buy-new-btn" v-if="loss_status" @click.stop="OpenPage">购买新水杯</div>
    <div class="lose-btn" @click.stop="$emit('openChoiceModel', item.id)" v-if="loss_status">重新绑定</div>
    <div class="child-info">
      <div class="child-head">
        <img :src="sex === 1 ? Family5 : Family6" />
      </div>
      <div class="child-content">
        <div class="child-name flex-c">
          <div class="line-clamp child-name-student">{{item.student_name}}</div>
          <img :src="IconEdit" class="edit-icon" v-if="!loss_status" @click.stop="$emit('openEditName')">
          <div class="labelname" v-if="item.is_family * 1 == 1">亲友</div>
        </div>
        <div class="child-schoole">
          <span>{{item.school}}-{{item.class}}</span>
          <span class="again" @click.stop="$emit('openChiceClass', item)" v-if="!loss_status">编辑班级</span>
          <!-- <img :src="IconEdit" class="edit-icon" @click.stop="$emit('openChiceClass')" v-if="!loss_status" /> -->
        </div>
        <div class="time">
          <span>截止时间</span>
          <span>{{item.end_time}}</span>
          <span class="again" @click.stop="AgainBuy" v-if="!loss_status">继续订购</span>
        </div>
      </div>
    </div>
    <div class="three-btn">
      <div class="btn-item" @click.stop="$nav('Family.Relationship', {id: item.id})">
        <img :src="IconGroup" />
        <div class="title">关系管理</div>
      </div>
      <div class="btn-item" @click.stop="$nav('Common.ModelInfo', {id: item.id})">
        <img :src="IconModel" />
        <div class="title">模式信息</div>
      </div>
      <div class="btn-item" @click.stop="$nav('Family.DrinkInfo', {id: item.id})">
        <img :src="IconCup" />
        <div class="title">饮水情况</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    methods: {
      AgainBuy () {
        this.$ShowConfirm(
          '1、当前使用模式未到使用结束时间时，您可以直接订购下一个模式，新模式直到当前模式使用完毕后才生效。\n2、如果继续订购的是当前模式，且当前模式已支付押金，不需要重复支付押金。',
          {
            title: '温馨提示',
            showCancel: false,
            messageAlign: 'left',
            confirmText: '我知道了'
          }
        ).then(() => {
          this.$nav('Common.ModelChoice', { id: this.item.id })
        })
      },
      OpenPage () {
        window.location.href = this.buyUrl
      }
    },
    computed: {
      ...SetImage(['Family5', 'Family6', 'IconCup', 'IconGroup', 'IconModel', 'IconEdit'])
    },
    props: {
      sex: null,
      loss_status: {
        type: Boolean,
        default: false
      },
      classList: {
        type: Object,
        default: () => ({})
      },
      item: {
        type: Object,
        default: () => ({})
      },
      buyUrl: null
    }
  }
</script>

<style lang="less" scoped>
  .child-item {
    .br(.1rem);
    overflow: hidden;
    box-shadow: 0rem 0.06rem 0.2rem 0rem rgba(0, 154, 214, 0.14);
    position: relative;
    & + .child-item {
      .mt(.3rem);
    }
    .buy-new-btn {
      .bg(#007dd5);
      .h(.4rem);
      .br(.2rem);
      .p(0 .13rem);
      .lh(.4rem);
      .c(#fff);
      .fz(.2rem);
      position: absolute;
      top: 1.24rem;
      right: .24rem;
    }
    .lose-btn {
      position: absolute;
      top: .37rem;
      right: .24rem;
      z-index: 10;
      .p(0 .18rem);
      .h(.34rem);
      .br(.17rem);
      .bg(#fff);
      .fz(.2rem);
      .c(#ff2c4c);
      .flex-cc();
      .mt(.09rem);
    }
    &.loss_status {
      .child-info {
        .child-head {
          position: relative;
          &::after {
            content: '已挂失';
            position: absolute;
            .w();
            .h();
            .br(inherit);
            top: 0;
            left: 0;
            z-index: 10;
            .c(#fff);
            .flex-cc();
            .bg(rgba(0, 0, 0, .3));
          }
        }
        .child-name,
        .child-schoole,
        .time {
          .c(#c4c4c4);
        }
      }
    }
    .child-info {
      .h(1.9rem);
      .pl(.3rem);
      .flex-c();
      .bg(#effaff);
      .child-head {
        .w(1.3rem);
        .h(1.3rem);
        .mr(.3rem);
        .br(.65rem);
        img {
          .w();
          .h();
        }
      }
      .child-name {
        .fz(.32rem);
        .c(#333);
        font-weight: bold;
        .mb(.08rem);
        height: 0.4rem;
        .child-name-student {
          max-width: 3.2rem;
          line-height: 0.4rem;
          padding-top: 0.04rem;
        }
        .labelname {
          font-size: 0.26rem;
          padding: 0.05rem 0.2rem 0;
          height: 0.32rem;
          line-height: 0.32rem;
          background-image: linear-gradient(-90deg, #3c7ef8 0%, #3a9cff 100%),
            linear-gradient(#c4c4c4, #c4c4c4);
          background-blend-mode: normal, normal;
          box-shadow: 0px 6px 14px 0px rgba(60, 126, 248, 0.24);
          border-radius: 0.3rem;
          margin-left: 0.2rem;
          color: #fff;
          font-weight: normal;
        }
      }
      .child-schoole {
        .fz(.26rem);
        .c(#999);
        .mb(.3rem);
        .flex-c();
        .again {
          .fz(.24rem);
          .c(#388bff);
          .ml(.28rem);
        }
      }
      .edit-icon {
        .w(.3rem);
        .h(.3rem);
        .ml(.18rem);
        vertical-align: middle;
      }
      .time {
        .fz(.26rem);
        .flex-c();
        .c(#999);
        span + span {
          .ml(.28rem);
        }
        .again {
          .fz(.24rem);
          .c(#388bff);
        }
      }
    }
    .three-btn {
      .p(0 .25rem);
      .h(1.47rem);
      .bg(#fff);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn-item {
        .flex-ccc();
        img {
          .w(.46rem);
          .h(.39rem);
          .mb(.12rem);
          object-fit: contain;
        }
        .title {
          .fz(.28rem);
          .c(#666);
        }
      }
    }
  }
</style>
